import { UI } from "@wwimmo/ui";
import React, { useCallback, useContext } from "react";
import { RootStoreContext } from "src/stores/RootStore";
import { SORT_DIRECTION, SORT_FIELD } from "src/stores/tickets/TicketListStore";
import styles from "./TicketsListSort.module.css";

/**
 * SortIcon component that handles rendering the sort icon with appropriate classes
 */
export const SortIcon = ({ isActive, sortDirection }: { isActive: boolean; sortDirection?: SORT_DIRECTION }) => {
    const iconClasses = [styles.sortIcon, isActive ? styles.sortIconActive : "", isActive ? styles.sortIconPrimary : ""]
        .filter(Boolean)
        .join(" ");

    // Use different icons based on sort direction
    const icon = isActive
        ? sortDirection === SORT_DIRECTION.DESC
            ? UI.SVGIcon.ChevronDown
            : UI.SVGIcon.ChevronUp
        : UI.SVGIcon.ChevronUpThin;

    return <UI.Icon icon={icon} size="small" className={iconClasses} />;
};

/**
 * Component for sortable header cells
 */
export const SortableHeaderCell = ({
    field,
    label,
    colspan,
    className,
    currentSortField,
    currentSortDirection
}: {
    field: SORT_FIELD;
    label: React.ReactNode;
    colspan: number;
    className?: string;
    currentSortField?: SORT_FIELD;
    currentSortDirection?: SORT_DIRECTION;
}) => {
    const { ticketListStore } = useContext(RootStoreContext);
    const handleSort = useCallback(() => {
        ticketListStore.setSortField(field);
    }, [field, ticketListStore]);

    const isActive = currentSortField === field;

    return (
        <UI.List.Cell
            key={field}
            colspan={colspan}
            className={className}
            value={
                <div className={styles.sortableHeader} onClick={handleSort}>
                    <span>{label}</span>
                    <SortIcon isActive={isActive} sortDirection={currentSortDirection} />
                </div>
            }
            truncate
        />
    );
};
